<div class="snack-container">
	<div class="text">
		{{ options.message }}
	</div>
</div>
